module.exports={
    url:"https://dot-backend-indus.michelin.com/v1",
    azure_image_storage_endpoint:"https://dev.api.michelin.com/sfdc-az-img/" //dev, qa and rqa
    // azure_image_storage_endpoint:"https://dev.api.michelin.com/3cp-tire-sfdcazimg/v1" // uat

}
